import api from '@/api';
import moment from 'moment';

const state = {
  activities: [],
};

const getters = {
};

const actions = {
  async getPreSaleAnalysisActivities({ commit }, payload) {
    const response = await api.post('Activity/PreSaleAnalysisActivities', {
      OpportunityStatusId: payload.opportunityStatus,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });
    commit('activities', response.data.activities);
  },
  async exportToExcel({ state }) {
    const argument = {};
    argument.activities = state.activities;
    const response = await api.post('Reports/ExportPreSaleAnalysisActivitiesReportToExcel', argument, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `PreSaleAnalysisActivities_${state.activities[0].opportunityStatus.name}_${moment().format('YYYY-MM-DD')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },
};

const mutations = {
  activities(state, payload) {
    state.activities = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
